import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateRegisterStep } from '../../../../redux/actions/userActions';
import { collaboratorSizeRangeService } from '../../../../services/napoleon';
import { REGISTER_STEPS, STEP_ORDER } from '../../../../constants/registerSteps';
import * as Steps from './steps';

export default function RegisterForm() {
  const dispatch = useDispatch();
  const { currentStep, authByGoogle } = useSelector((state) => state.registerStepReducer);
  const [collaboratorSizeRange, setCollaboratorSizeRange] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleBack = () => {
    if (currentStep > 0) {
      dispatch(updateRegisterStep(currentStep - 1));
    }
  };

  const handleNext = () => {
    if (currentStep < STEP_ORDER.length - 1) {
      dispatch(updateRegisterStep(currentStep + 1));
    }
  };

  useEffect(() => {
    setIsFetchingData(true);

    collaboratorSizeRangeService
      .getAll()
      .then((response) => {
        const { data } = response;
        setCollaboratorSizeRange(data);
        setIsError(false);
      })
      .catch(() => {
        setCollaboratorSizeRange([]);
        setIsError(true);
      })
      .finally(() => setIsFetchingData(false));
  }, []);

  const stepComponents = {
    [REGISTER_STEPS.SIGN_IN_INFO]: <Steps.SignInInfo handleNext={handleNext} />,
    [REGISTER_STEPS.USER_INFO]: (
      <Steps.UserInfo
        handleBack={handleBack}
        handleNext={handleNext}
        disableBack={!!authByGoogle?.authProvider}
      />
    ),
    [REGISTER_STEPS.COMPANY_INFO]: (
      <Steps.CompanyInfo handleBack={handleBack} handleNext={handleNext} />
    ),
    [REGISTER_STEPS.COMPANY_ADDRESS]: (
      <Steps.CompanyAddress handleBack={handleBack} handleNext={handleNext} />
    ),
    [REGISTER_STEPS.COLLABORATORS]: (
      <Steps.NumberOfCollaborators
        handleBack={handleBack}
        handleNext={handleNext}
        collaboratorSizeRange={collaboratorSizeRange}
        isFetchingData={isFetchingData}
        isError={isError}
      />
    ),
    [REGISTER_STEPS.DISCOUNT]: <Steps.DiscountCoupon handleBack={handleBack} />,
  };

  const currentStepKey = STEP_ORDER[currentStep];
  return stepComponents[currentStepKey] || null;
}
